/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    RequestTrackingPageResponse,
    RequestTrackingPageResponseFromJSON,
    RequestTrackingPageResponseToJSON,
    RequestTrackingStatisticsResponse,
    RequestTrackingStatisticsResponseFromJSON,
    RequestTrackingStatisticsResponseToJSON,
} from '../models';

export interface GetErrorDistributionRequest {
    startTime?: Date;
    endTime?: Date;
}

export interface GetRequestsByDeviceRequest {
    macAddress: string;
    page?: number;
    pageSize?: number;
    limit?: number;
}

export interface GetRequestsByModeRequest {
    mode?: GetRequestsByModeModeEnum;
    page?: number;
    pageSize?: number;
    startTime?: Date;
    endTime?: Date;
}

export interface GetTrackingStatisticsRequest {
    startTime?: Date;
    endTime?: Date;
}

/**
 * 
 */
export class RequestTrackingApi extends runtime.BaseAPI {

    /**
     * Get request tracking statistics for the last 24 hours
     */
    async getDailyTrackingStatisticsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<RequestTrackingStatisticsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tracking/statistics/daily`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestTrackingStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Get request tracking statistics for the last 24 hours
     */
    async getDailyTrackingStatistics(initOverrides?: RequestInit): Promise<RequestTrackingStatisticsResponse> {
        const response = await this.getDailyTrackingStatisticsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get error status code distribution
     */
    async getErrorDistributionRaw(requestParameters: GetErrorDistributionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<{ [key: string]: number; }>> {
        const queryParameters: any = {};

        if (requestParameters.startTime !== undefined) {
            queryParameters['startTime'] = (requestParameters.startTime as any).toISOString();
        }

        if (requestParameters.endTime !== undefined) {
            queryParameters['endTime'] = (requestParameters.endTime as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tracking/error-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get error status code distribution
     */
    async getErrorDistribution(requestParameters: GetErrorDistributionRequest = {}, initOverrides?: RequestInit): Promise<{ [key: string]: number; }> {
        const response = await this.getErrorDistributionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get request tracking statistics for the last 30 days
     */
    async getMonthlyTrackingStatisticsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<RequestTrackingStatisticsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tracking/statistics/monthly`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestTrackingStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Get request tracking statistics for the last 30 days
     */
    async getMonthlyTrackingStatistics(initOverrides?: RequestInit): Promise<RequestTrackingStatisticsResponse> {
        const response = await this.getMonthlyTrackingStatisticsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get requests by device MAC address
     */
    async getRequestsByDeviceRaw(requestParameters: GetRequestsByDeviceRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RequestTrackingPageResponse>> {
        if (requestParameters.macAddress === null || requestParameters.macAddress === undefined) {
            throw new runtime.RequiredError('macAddress','Required parameter requestParameters.macAddress was null or undefined when calling getRequestsByDevice.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tracking/device/{macAddress}`.replace(`{${"macAddress"}}`, encodeURIComponent(String(requestParameters.macAddress))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestTrackingPageResponseFromJSON(jsonValue));
    }

    /**
     * Get requests by device MAC address
     */
    async getRequestsByDevice(requestParameters: GetRequestsByDeviceRequest, initOverrides?: RequestInit): Promise<RequestTrackingPageResponse> {
        const response = await this.getRequestsByDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get requests by mode (slowest or errors)
     */
    async getRequestsByModeRaw(requestParameters: GetRequestsByModeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RequestTrackingPageResponse>> {
        const queryParameters: any = {};

        if (requestParameters.mode !== undefined) {
            queryParameters['mode'] = requestParameters.mode;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.startTime !== undefined) {
            queryParameters['startTime'] = (requestParameters.startTime as any).toISOString();
        }

        if (requestParameters.endTime !== undefined) {
            queryParameters['endTime'] = (requestParameters.endTime as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tracking/requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestTrackingPageResponseFromJSON(jsonValue));
    }

    /**
     * Get requests by mode (slowest or errors)
     */
    async getRequestsByMode(requestParameters: GetRequestsByModeRequest = {}, initOverrides?: RequestInit): Promise<RequestTrackingPageResponse> {
        const response = await this.getRequestsByModeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get request tracking statistics for custom time range
     */
    async getTrackingStatisticsRaw(requestParameters: GetTrackingStatisticsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RequestTrackingStatisticsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.startTime !== undefined) {
            queryParameters['startTime'] = (requestParameters.startTime as any).toISOString();
        }

        if (requestParameters.endTime !== undefined) {
            queryParameters['endTime'] = (requestParameters.endTime as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tracking/statistics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestTrackingStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Get request tracking statistics for custom time range
     */
    async getTrackingStatistics(requestParameters: GetTrackingStatisticsRequest = {}, initOverrides?: RequestInit): Promise<RequestTrackingStatisticsResponse> {
        const response = await this.getTrackingStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get request tracking statistics for the last 7 days
     */
    async getWeeklyTrackingStatisticsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<RequestTrackingStatisticsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/tracking/statistics/weekly`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestTrackingStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Get request tracking statistics for the last 7 days
     */
    async getWeeklyTrackingStatistics(initOverrides?: RequestInit): Promise<RequestTrackingStatisticsResponse> {
        const response = await this.getWeeklyTrackingStatisticsRaw(initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum GetRequestsByModeModeEnum {
    Slowest = 'slowest',
    Errors = 'errors'
}
